<template>
  <BaseNode v-bind="props" class="question-node">
    <template #header>
      <BaseHtmlContent class="node__title" :html="processText(node.title, decisionTree.context)" />
    </template>
    <template #body>
      <BaseHtmlContent class="node__message" :html="node.message" />
      <BaseTileGrid v-if="node.isRadioInputType" class="question-node-grid" width-breakpoints="50ch">
        <template v-for="answer in node.answers">
          <BaseTileGridItem class="answer" type="radio">
            <BaseRadioButton
              v-model="node.selectedAnswerId"
              :label="answer.title"
              :value="answer.id"
              :test-id="TestId.booking.choice"
            />
          </BaseTileGridItem>
          <BaseHtmlContent class="node__description --tile-grid" :html="answer.description" />
        </template>
      </BaseTileGrid>
      <div v-else-if="node.isTextEntryInputType">
        <BaseTextField v-model="node.enteredText" />
        <BaseHtmlContent
          v-if="node.selectedAnswer?.description"
          class="node__description --selected-answer"
          :html="node.selectedAnswer.description"
        />
      </div>
      <div v-else>
        <BaseSelect v-model="node.selectedAnswerId" :options="options" :test-id="TestId.booking.select"></BaseSelect>
        <BaseHtmlContent
          v-if="node.selectedAnswer?.description"
          class="node__description --selected-answer"
          :html="node.selectedAnswer.description"
        />
      </div>
    </template>
  </BaseNode>
</template>

<script setup>
import { computed } from "vue";
import { useSnippetProcessor } from "#/decision_tree_viewer/composables/useSnippetProcessor";
import { TestId } from "#/test-ids";

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  decisionTree: {
    type: Object,
    required: true,
  },
});

const options = computed(() =>
  props.node.answers.map((answer) => ({
    label: answer.title,
    value: answer.id,
  })),
);

const { processText } = useSnippetProcessor();
</script>

<style lang="scss" scoped>
.question-node-grid {
  --sp-comp-dtv-tile-grid-columns: 1; // smaller than 50ch == stacked layout

  // MODIFIERS
  &.--sp-bp-width-gt-50ch {
    --sp-comp-dtv-tile-grid-columns: 2; // greater than 50ch change to column layout
    .answer {
      grid-row: 1 / 2;
      height: auto;
    }
  }
  .node__description {
    &.--tile-grid {
      --sp-comp-dtv-node-description-padding: 0 var(--sp-comp-dtv-tile-grid-item-padding, 0.75rem);
    }
  }
}
.node__description.--selected-answer {
  --sp-comp-dtv-node-description-padding: 1rem;
}
</style>
